// import Plug from 'assets/svg/plug.svg';

export function getImagePath(img?: string | null) {
  if (!img) return '';
  return process.env.REACT_APP_PUBLIC_DOMAIN + '/' + img;
}
